import { ErrorHandler, Injectable } from '@angular/core';

const CHUNK_RELOAD_MARKER_KEY = 'ba:chunk-reload-marker';
const CHUNK_RELOAD_COOLDOWN_MS = 60_000;

const CHUNK_FAILURE_MESSAGE =
    /ChunkLoadError|Loading chunk [\d]+ failed|Failed to fetch dynamically imported module|Failed to load module script|Importing a module script failed|MIME type.*text\/html/i;

export function isChunkLoadFailureMessage(message: string): boolean {
    return CHUNK_FAILURE_MESSAGE.test(message);
}

function reloadOnce(): boolean {
    const last = sessionStorage.getItem(CHUNK_RELOAD_MARKER_KEY);
    if (last && Date.now() - Number(last) < CHUNK_RELOAD_COOLDOWN_MS) {
        return false;
    }
    sessionStorage.setItem(CHUNK_RELOAD_MARKER_KEY, String(Date.now()));
    const url = new URL(window.location.href);
    url.searchParams.set('_ba', Date.now().toString());
    window.location.replace(url.toString());
    return true;
}

export function reloadOnChunkLoadError(error: unknown): boolean {
    if (error == null) {
        return false;
    }

    if (typeof error === 'string') {
        return isChunkLoadFailureMessage(error) && reloadOnce();
    }

    if (typeof error !== 'object') {
        return false;
    }

    const candidate = error as { name?: string; message?: string; cause?: unknown };

    if (candidate.name === 'ChunkLoadError') {
        return reloadOnce();
    }

    const message = String(candidate.message ?? '');
    if (isChunkLoadFailureMessage(message)) {
        return reloadOnce();
    }

    if (candidate.cause != null && reloadOnChunkLoadError(candidate.cause)) {
        return true;
    }

    return false;
}

@Injectable()
export class ChunkLoadErrorHandler implements ErrorHandler {
    handleError(error: unknown): void {
        if (reloadOnChunkLoadError(error)) {
            return;
        }
        console.error(error);
    }
}
